export * from './docker.image.reader.service';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/docker/src/image/index.ts